import type { BuildingSocietySavingsOverviewConfig } from '../../BuildingSocietySavingsOverviewConfig';

export const savingsOverview: BuildingSocietySavingsOverviewConfig = {
    showAdjustableOverview: false,
    showCollapsibleDetails: false,
    showTargetAmount: false,
    highlights: {
        displayCreditInterestRate: false,
        displayExpiryDate: false,
        displayDetailedBalanceHighlights: false,
        displayMonthlyAmount: false,
    },
    list: {
        displayAgreementNumber: false,
        displayContractHolders: false,
        displayContractAmount: false,
        displayTargetAmount: false,
        displaySigningDate: false,
        displayExpiryDate: false,
        displayIbanAndBic: false,
        displayAccountNumberAndBankCode: false,
        displayBalance: false,
        displayBonusBearingMonthlySavings: false,
        displayBonusBearingDepositDone: false,
        displayBonusBearingDepositToPay: false,
        displayNotRequestedBonus: false,
        displayCreditInterestRate: false,
        displayBeneficiaries: false,
        displaySubProductI18N: false,
        displayInitialDepositDate: false,
        displayFeeInfo: false,
        displayMinimumSavingsPeriod: false,
        displayTerminationPayout: false,
    },
    collapsibleList: {
        displayAgreedMonthlySavings: false,
        displaySigningDate: false,
        displayLoanEntitlementDate: false,
        displayTargetAmount: false,
        displayStatementDistribution: false,
        displayStateSupportStatementAgreed: false,
        displayStateSupportBonusAgreed: false,
    },
};
